export var GroupId;
(function (GroupId) {
    GroupId["AdditionalData"] = "AdditionalData";
    GroupId["AdsManagerGetStarted"] = "AdsManagerGetStarted";
    GroupId["BankAccount"] = "BankAccount";
    GroupId["BusinessSize"] = "BusinessSize";
    GroupId["ContentStoreGetStarted"] = "ContentStoreGetStarted";
    GroupId["InStoreGetStarted"] = "InStoreGetStarted";
    GroupId["InStoreLegalForm"] = "InStoreLegalForm";
    GroupId["InStoreRegisteredAddress"] = "InStoreRegisteredAddress";
    GroupId["InStoreRegistration"] = "InStoreRegistration";
    GroupId["InStoreStakeholder"] = "InStoreStakeholder";
    GroupId["InStoreStores"] = "InStoreStores";
    GroupId["InStoreVat"] = "InStoreVat";
    GroupId["ProductChannel"] = "ProductChannel";
    GroupId["SensitiveGoods"] = "SensitiveGoods";
})(GroupId || (GroupId = {}));
